import { render, staticRenderFns } from "./orgManage.vue?vue&type=template&id=1f9540fc&scoped=true"
import script from "./orgManage.vue?vue&type=script&lang=js"
export * from "./orgManage.vue?vue&type=script&lang=js"
import style0 from "./orgManage.vue?vue&type=style&index=0&id=1f9540fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9540fc",
  null
  
)

export default component.exports